<template>
  <div>
    <CRow>
      <CCol md="6">
        <CRow>
          <CCol col="12">
            <label class="small" v-translate translate-context="qrcode.label">Background color</label>
            <PColorPicker :color="background"
                          disable-alpha
                          @change="color => background = color.hex"/>
          </CCol>
          <CCol col="12">
            <label class="small" v-translate translate-context="qrcode.label">Foreground color</label>
            <PColorPicker :color="foreground"
                          disable-alpha
                          @change="color => foreground = color.hex"/>
          </CCol>
        </CRow>
      </CCol>

      <CCol md="6">
        <div>
          <label v-translate translate-context="qrcode.label" class="d-block small">Preview</label>
          <div class="border p-2 qr-code d-inline-block mb-3" style="border-radius: 12px">
            <qrcode-vue
                ref="qrcode"
                :value="value"
                :size="size"
                :render-as="renderAs"
                :background="background"
                :foreground="foreground"
            />
          </div>
          <div>
            <label v-translate translate-context="qrcode.label" class="d-block small">Download file</label>
            <CButton @click="download('svg')" size="sm" color="secondary"
                     class="mr-2">
              <CIcon class="text-primary" name="cipDownload03"/>
              .svg
            </CButton>
             <CButton @click="download('canvas')" size="sm" color="secondary">
              <CIcon class="text-primary" name="cipDownload03"/>
              .png
            </CButton>
          </div>
        </div>

      </CCol>
    </CRow>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import {downloader} from "@/domain/core/components/qrcode/downloader";
import PColorPicker from "@/domain/core/components/PColorPicker.vue";

export default {
  name: "QRCodeGenerator",
  components: {PColorPicker, QrcodeVue},
  props: {
    value: {
      type: String,
      required: true
    },
    fileName: {
      type: String,
      default: 'QRCode'
    }
  },
  data() {
    return {
      size: 200,
      renderAs: 'svg',
      background: '#ffffff',
      foreground: '#000000'
    }
  },
  methods: {
    async download(fileType) {
      this.renderAs = fileType
      await this.$nextTick()
      if (this.renderAs === 'svg') {
        const qrcode = this.$refs.qrcode.$el.querySelector('svg')
        downloader.fromSvg(qrcode, this.fileName + '.svg')
      } else {
        const qrcode = this.$refs.qrcode.$el.querySelector('canvas')
        downloader.fromPngCanvas(qrcode, this.fileName + '.png')
      }
    },
  },
}
</script>